<template>
  <div class="relative overflow-hidden bg-gradient-to-r from-accent/5 to-gradient-end/5 py-20 dark:from-accent/10 dark:to-gradient-end/10">
    <div class="container relative mx-auto px-6">
      <div v-reveal class="mx-auto max-w-4xl text-center">
        <h2 class="mb-6 text-3xl font-bold text-ternary-dark dark:text-primary-light sm:text-4xl">
          {{ title }} <span class="bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-transparent">{{ highlightedTitle }}</span>
        </h2>
        <p class="mb-8 text-lg text-gray-600 dark:text-gray-400">
          {{ description }}
        </p>
        <div class="flex flex-col gap-4 sm:flex-row sm:justify-center">
          <NuxtLink
            to="/contact"
            class="inline-flex items-center justify-center rounded-2xl bg-gradient-to-r from-accent to-gradient-end px-8 py-4 font-semibold text-white shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-glow"
          >
            <PhEnvelope class="mr-2 size-5" />
            {{ primaryButtonText }}
          </NuxtLink>
          <NuxtLink
            :to="secondaryButtonLink"
            class="inline-flex items-center justify-center rounded-2xl border-2 border-accent px-8 py-4 font-semibold text-accent transition-all duration-300 hover:bg-accent hover:text-white"
          >
            <PhArrowLeft class="mr-2 size-5" />
            {{ secondaryButtonText }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PhArrowLeft, PhEnvelope } from '@phosphor-icons/vue'

interface Props {
  title: string
  highlightedTitle: string
  description: string
  primaryButtonText?: string
  secondaryButtonText?: string
  secondaryButtonLink?: string
}

withDefaults(defineProps<Props>(), {
  primaryButtonText: 'Start Your Project',
  secondaryButtonText: 'View All Services',
  secondaryButtonLink: '/services',
})
</script>
